document.addEventListener("change", function (e) {
  const input = e.target.closest(
    'input[type="radio"][data-image-url]'
  );
  if (!input) return;

  const imageUrl = input.dataset.imageUrl;
  if (!imageUrl) return;

  const card = input.closest(".card-product-custom-div");
  if (!card) return;

  // نفس فكرة product-info: إعادة بناء الميديا
  const mediaContainer = card.querySelector('[data-media-container]');
  if (!mediaContainer) return;

  const productUrl =
    input.dataset.variantId
      ? `${card.querySelector('a').href.split('?')[0]}?variant=${input.dataset.variantId}`
      : card.querySelector('a').href;

  mediaContainer.innerHTML = `
    <img
      src="${imageUrl}"
      alt=""
      class="motion-reduce"
      loading="eager"
      width="533"
      height="533"
    >
  `;

  // تحديث اللينكات
  card.querySelectorAll(
    'a[id^="CardLink-"], a[id^="StandardCardNoMediaLink-"]'
  ).forEach(link => {
    link.href = productUrl;
  });
});
